import { render, staticRenderFns } from "./box-swapping.vue?vue&type=template&id=c8929566&scoped=true&"
import script from "./box-swapping.vue?vue&type=script&setup=true&lang=ts&"
export * from "./box-swapping.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./box-swapping.vue?vue&type=style&index=0&id=c8929566&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8929566",
  null
  
)

export default component.exports